import { SearchInput, Stack } from '@genial/components';
import { useBreakpointValue } from '@genial/utils';
import { useNavigation } from '@react-navigation/native';
import React, { useCallback, useMemo } from 'react';
import { useRecoilValue } from 'recoil';

import { SignedInNavigationScreenNavigationProp } from '../../../routes/types';
import { dividendHistoryFilterAtom } from '../../../store/dividendHistory/atom';
import { FilterButton } from '../../BatchTicket/components/SectionWrapper/button';

export namespace SearchAndFilterButtonTypes {
  export type Props = {
    onSearch: (term: string) => void;
    isLoading?: boolean;
    isMobile: boolean;
  };
}

export const SearchAndFilterButton: React.FC<SearchAndFilterButtonTypes.Props> = ({
  isLoading,
  onSearch,
  isMobile,
}) => {
  const dividendHistoryFilters = useRecoilValue(dividendHistoryFilterAtom);
  const navigation = useNavigation<SignedInNavigationScreenNavigationProp>();

  const toggleFilterModal = useCallback(() => {
    navigation.navigate('DividendHistoryFilterModal');
  }, [navigation]);

  const handleSearch = useCallback(
    (term: string) => {
      onSearch(term);
    },
    [onSearch]
  );

  const handleClear = useCallback(() => {
    onSearch('');
  }, [onSearch]);

  const contentAlignment = useBreakpointValue({ base: 'flex-start', sm: 'center' });

  const filterCount = useMemo(() => {
    const appliedFilterCount = dividendHistoryFilters.appliedFilters.length;

    return appliedFilterCount === 0 ? 1 : appliedFilterCount;
  }, [dividendHistoryFilters.appliedFilters]);

  return (
    <Stack
      direction={{ base: 'column', sm: 'row' }}
      alignItems={contentAlignment}
      justifyContent="space-between"
      width="full">
      <SearchInput
        isLoading={isLoading}
        isMobile={isMobile}
        onSearch={handleSearch}
        onClear={handleClear}
        placeholder="Pesquise por Empresa, ISIN, Código ou Ativo"
      />
      <FilterButton
        isDisabled={!!isLoading}
        onPress={toggleFilterModal}
        count={filterCount}
        isMobile={false}
      />
    </Stack>
  );
};
